import styled from 'styled-components';

export const StyledLink = styled.a``;

export const Image = styled.img`
    width: 766px;
`;
